import React, { useEffect, useRef } from 'react';
import { LocatorMapProps } from './types';
import './locator-map.css';

const LocatorMap = (props: LocatorMapProps) => {
	const { location, viewport } = props;

	const mapRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const initMap = async (location: {
			lat: number;
			lng: number;
		}): Promise<void> => {
			// Load libraries according to documentation.
			const { Map } = (await google.maps.importLibrary(
				'maps',
			)) as google.maps.MapsLibrary;

			const { AdvancedMarkerElement } = (await google.maps.importLibrary(
				'marker',
			)) as google.maps.MarkerLibrary;

			// Maps now require a map ID we create in the Google console
			const map = new Map(mapRef.current as HTMLElement, {
				zoom: 13,
				mapTypeControl: false,
				zoomControl: false,
				fullscreenControl: false,
				streetViewControl: false,
				center: location,
				mapId: process.env.NEXT_PUBLIC_GOOGLE_MAP_ID,
			});

			new AdvancedMarkerElement({
				map,
				position: location,
			});

			// If the place has a geometry, then present it on a map.
			if (viewport) {
				map.fitBounds(viewport);
			} else {
				map.setCenter(location);
				map.setZoom(13);
			}
		};

		if (location && typeof google !== 'undefined') {
			initMap(location);
		}
	}, [location, viewport]);

	return (
		<div
			id="map"
			ref={mapRef}
			className="mt-10 h-52 w-full max-w-5xl overflow-hidden rounded-2xl md:h-60"
		></div>
	);
};

export default LocatorMap;
